module.exports = "/packs/images/svg/facilities/gym~ea50d1ca9ec05764f77d749984c8fb1e.svg";